import * as Actions from '../../actions';

const initialState = { data: null };

const generalRouteStatsReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_GENERAL_STATS:
            return { ...state, data: { ...action.payload } };
        default:
            return state;
    }
};

export default generalRouteStatsReducer;
